import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { RootService } from '../shared/services/root.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../shared/services/apiService.service';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { environment } from '../../environments/environment';
import { SkeletonService } from '../shared/services/skeleton.service';
import { setImageUrl } from '../fni-modules/shared/helper/common_function';
import { SeoService } from '../shared/seo/seo.service';
import { CanonicalService } from '../shared/seo/canonical.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  topMenu: any;
  tagList: any;
  headerMenu: any = [];
  sub: Subscription = new Subscription();
  videoData: any = [];
  promotionalVideos: any = [];
  promovideosLoaded: boolean = false;
  testSafeUrl!: SafeResourceUrl;
  offersData: any;

  environment1 = environment.s3bucket.url;
  showLoader: any = false;
  productLoaded: boolean = false;
  OfferLoaded: boolean = false;
  isUserLoggedIn: boolean;
  locationDeniedNotificationShown = false;

  metatitle =
    'Buy Tata Trucks and Buses Online in India - Tata Motors';
  metadesc =
    'Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers..';
  brandVideoSize: any = 0;
  videoTotalCount: any = 0;
  isMobile = true;
  dealerCode: any;
  highlightmasterData: any = [];

  count = 0;
  duration = 4000;
  dealerLen: any = [];
  offerData: any = [];
  locationData: any;
  constructor(private rootService: RootService,
    private apiService: ApiService, private cleverService: ClevertapService, public skeletonService: SkeletonService,
    private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object, private router: Router,
    private seoservice: SeoService, private canonicalservice: CanonicalService, private route: ActivatedRoute,
    private toastrService: ToastrService,
    private behaviorService: BehaviourSubjectService
  ) {
    this.sub.add(this.route.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem("dealercd", params['dealer']);
        }
          this.getDealer()
        
      }
    }));
  }
  ngOnInit() {
           const url = this.router.url;
          const trimmedUrl = url.startsWith('/') ? url.substring(1) : url;
          console.log(trimmedUrl);
          this.canonicalservice.createCanonicalURL(trimmedUrl);
    this.sub.add(
      this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;

        if (this.isUserLoggedIn ) {
          if (isPlatformBrowser(this.platformId)) {
          let isNotificationPop = JSON.parse(localStorage.getItem('userPincode')) ? true : false
          if(!isNotificationPop){
          this.requestNotificationPermission();
          }else {
          }
        }
        }   
      })
    );
    this.behaviorService.offerdetailsvisible.next(false)
    this.behaviorService.isSmart.next(false);
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('previousUrl')
    localStorage.removeItem('isproductdetail')
    localStorage.removeItem('tat_id');
    localStorage.removeItem('unbxFilterValue');
    localStorage.removeItem('normalFilterValue');
    }
    // this.canonicalservice.createCanonicalURL('');
    this.seo();

    if (isPlatformBrowser(this.platformId)) {
      this.dealerCode= localStorage.getItem("dealercd");

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      localStorage.removeItem("filterValue");
      }
      try {
        this.cleverService.onPageView("Home");
      } catch { }
    

  }
  loading: boolean = false;
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (isPlatformBrowser(this.platformId)) {

      if (window.innerHeight + window.scrollY + 550 >= document.body.offsetHeight && !this.loading) {
        this.loading = true;
        this.getPromotionalVideoData(10);
        this.getOfferDetails();

    this.gethighlighhtmasterData()
      }
    }
  }
  onScrollDiv(){
    const box = document.getElementById('brandVideoDiv');
    const scrollableHeight = box.scrollHeight - box.clientHeight

    if ((box.scrollTop + 10) >= scrollableHeight) {
        this.getPromotionalVideoData(10);
    }

  }
  getData(data:any,type){
if(type == 0){
return data.substring(0, data.indexOf(' '))
}else{
return data.substring(data.indexOf(' ') + 1)
}
  }
  getPromotionalVideoData(size) {
    if(this.brandVideoSize > (this.videoTotalCount + 10)){
      return false;
    }else{

      this.brandVideoSize += size;
      let reqBody = {
        "category": "marketing",
        "status": "APPROVED",
        pl: '',
        ppl: '',
        lob: '',
        vc: '',
        size: this.brandVideoSize,
        offset: 0
      };
      this.showLoader = true;
      this.sub.add(this.apiService.getbrandVideosDetail(reqBody).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.videoData = response.data;
            this.videoTotalCount = response.total_count;
            this.videoDetail(this.videoData, response.total_count);
          }
        },
        error: () => {
          this.productLoaded = true;
          this.showLoader = false;
        },
        complete: () => { }
      }))
    }

  }

  getDealer() {
    let data;
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    
       data = {
        "dealer_code": localStorage.getItem("dealercd"),
        "action_type": "dropdown"
    };
  }
      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.dealerLen = response?.data;

            if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem("dealername", (this.dealerLen[0].division_name + '_' + this.dealerLen[0].dealer_code))
            }
            this.behaviorService.dealerName.next(true)

          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );

    
  
  }
  getUserLocation() {
    if (isPlatformBrowser(this.platformId)) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          const accuracy = position.coords.accuracy;
  
          this.showNotification('Location Access Granted', 'You allow us to access your location.');
  
          setTimeout(() => {
            this.sendLocationToApi(lat, lon);
          }, 2000);
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            if (isPlatformBrowser(this.platformId)) {
            const locationDeniedShown = localStorage.getItem('locationDeniedNotificationShown');
            if (!locationDeniedShown) {
              localStorage.setItem('locationDeniedNotificationShown', 'true'); 
              this.showNotification('Location Access Denied', 'You denied location access.');
            }
          }
          } else {
            console.error('Geolocation error:', error.message);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }
  }
  
  
  sendLocationToApi(latitude: number, longitude: number) {
    const payload = { latitude, longitude }; 
    try {
      this.sub.add(
        this.apiService.getPincodeBaseOnLatLong(payload).subscribe({
          next: (response: any) => {
            if(response.success){
              this.locationData = response?.data;
              if (isPlatformBrowser(this.platformId)) {
              localStorage.setItem("userPincode", JSON.stringify(this.locationData?.pincode));
              }
              // localStorage.setItem('locationPermissionGranted', 'true');
            }
          },
          error: (error: any) => {
            console.error('Error sending location:', error);
          }
        })
      );
    } catch (err) {
      console.error('Unexpected error occurred:', err);
    }
  }
  // Function to request notification permission
  requestNotificationPermission() {

    if (Notification.permission === 'default') {
   
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          this.getUserLocation();
        } else if (permission === 'denied') {
          console.error('Notification permission denied.'); 
          // alert('Notifications are blocked. Please enable them in your browser settings to receive notifications.');
        }
      });
    } else if (Notification.permission === 'granted') {

      this.getUserLocation();
    } else if (Notification.permission === 'denied') {

      // alert('You have blocked notifications. Please enable them from your browser settings if you wish to receive notifications.');
    }
  }
 
  // Function to show notifications
  showNotification(title: string, body: string) {
    const options = {
      body,
      icon: 'assets/icon/location.png', // Optional icon
    };
    new Notification(title, options);
  }
  gethighlighhtmasterData() {

      let reqBody = {
        "action_type":"get"
      };
      this.showLoader = true;
      this.sub.add(this.apiService.gethighlightmasterdata(reqBody).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.highlightmasterData = response.data;
          }
        },
        error: () => {
          this.productLoaded = true;
          this.showLoader = false;
        },
        complete: () => { }
      }))
  }
  videoDetail(data: any, count: any) {
    for (var k = 0; k < data?.length; k++) {
      let urls = data[k].path;

      var vthaumbimage = this.youtube_parser(urls);
      let img = 'https://img.youtube.com/vi/' + vthaumbimage + '/mqdefault.jpg';
      let videos = 'https://www.youtube.com/embed/' + vthaumbimage + '';
      this.testSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videos);
      this.promotionalVideos.push({ video_url: this.testSafeUrl, image_url: img });

      this.promovideosLoaded = this.promotionalVideos?.length == count ? true : false;
    }

    setTimeout(() => {
      this.showLoader = false;
      this.productLoaded = true
    }, 5000);

  }

  youtube_parser(url: any) {
    
      var regExp =
        /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
      var match = url.match(regExp);
      return match && match[1]?.length == 11 ? match[1] : false;
    
  }


  // OpenVideo(obj) {
  //   return environment.s3bucket.url + obj
  // }
  getOfferDetails() {
    try {
      // this.sub.add(this.apiService.getOffersDetails().subscribe({

      let data = {
        "noOfCampaignOffers": 10,
      }
      this.sub.add(this.apiService.getCampaignOffers(data).subscribe({
        next: (res: any) => {
          this.offersData = res?.offers;
          this.OfferLoaded = true
        },
        error: () => {
          this.OfferLoaded = true
          // this.ToastrService.warning('Offers api not working. Please try after sometime.')
        },
        complete: () => {
        }
      }))
    } catch (error) {
      this.OfferLoaded = true
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  customOptionsPromotionalVideos: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 24,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
    ],
    responsive: {
      0: {
        items: 1.3
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 3.5
      }
    },
    nav: true
  }
  customOptionsAttractVechicle: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    margin: 24,
    nav: false,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
   ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      600: {
        items: 3
      },
      940: {
        items: 3.2
      },
      1199: {
        items: 3.2
      }
    },
  }

  getURL(URL) {
    let url = URL.includes('https://youtu.be/') ? URL?.replace('https://youtu.be/', '') :
      URL.includes('https://www.youtube.com/watch?v=') ? URL?.replace('https://www.youtube.com/watch?v=', '') :
        URL.includes('https://www.youtube.com/embed/') ? URL?.replace('https://www.youtube.com/embed/', '') : URL;
    return url;
  }

  navigateToOfferDetail(financierSchemeId) {
    this.router.navigate(['offer-details'], { queryParams: { financierSchemeId } });
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag('description', null, this.metadesc);
    this.seoservice.updateMetaTag(null, 'og:locale', 'en_US');
    this.seoservice.updateMetaTag(null, 'og:type', 'Website');
    this.seoservice.updateMetaTag(null, 'og:title', this.metatitle);
    this.seoservice.updateMetaTag(null, 'og:description', this.metadesc);
    this.seoservice.updateMetaTag(
      null,
      'og:url',
      environment.baseUrl + this.router.url
    );
    this.seoservice.updateMetaTag(null, 'og:site_name', 'Tata OSP');
  }

  callConfigurator() {
      if (this.rootService.getUserData()) {
        if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('VASData')
        localStorage.removeItem('VASDataProfile')
        }
        this.router.navigate(['/configurator-home']);
      }
      else {
        if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('previousUrl', '/configurator-home')
        }
        this.router.navigate(['/login/']);
      }
    
  }
}
